// Workspace uses one module route and selects its visible view with `?tab=`.
export const WORKSPACE_BASE_PATH = '/workspace';
export const WORKSPACE_TAB_PARAM = 'tab';
export const DEFAULT_WORKSPACE_TAB = 'environments';
export const WORKSPACE_TABS = ['environments', 'rbac', 'reports', 'integrations'];

export function workspaceTabPath(tab = DEFAULT_WORKSPACE_TAB, extraParams = undefined) {
  const params = new URLSearchParams(extraParams);
  params.set(WORKSPACE_TAB_PARAM, WORKSPACE_TABS.includes(tab) ? tab : DEFAULT_WORKSPACE_TAB);
  return `${WORKSPACE_BASE_PATH}?${params.toString()}`;
}

export const WORKSPACE_TAB_PATHS = {
  environments: workspaceTabPath('environments'),
  rbac: workspaceTabPath('rbac'),
  reports: workspaceTabPath('reports'),
  integrations: workspaceTabPath('integrations'),
};

export function resolveWorkspaceTab(search = '') {
  const tab = new URLSearchParams(search).get(WORKSPACE_TAB_PARAM);
  return WORKSPACE_TABS.includes(tab) ? tab : DEFAULT_WORKSPACE_TAB;
}
